import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import SalaryToHourly from './pages/SalaryToHourly';
import StudentLoanEstimator from './pages/StudentLoanEstimator';
import TakeHomeTable from './pages/TakeHomeTable';
import SalaryPage from './pages/SalaryPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import About from './pages/About';
import Contact from './pages/Contact';
import HowToUse from './pages/HowToUse';
import './index.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/salary-to-hourly" element={<SalaryToHourly />} />
          <Route path="/student-loan-estimator" element={<StudentLoanEstimator />} />
          <Route path="/take-home-table" element={<TakeHomeTable />} />
          <Route path="/how-to-use" element={<HowToUse />} />
          <Route path="/salary/:amount" element={<SalaryPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;